"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.pagination.bx--pagination {\n  background: white;\n  border: 1px solid #e8e8e8;\n  overflow: hidden; }\n  .pagination.bx--pagination .bx--form-item {\n    margin-bottom: 0; }\n  .pagination.bx--pagination span.bx--pagination__text {\n    color: #4c4c4c; }\n  .pagination.bx--pagination .bx--pagination__left label.bx--pagination__text {\n    padding-right: 37px; }\n  .pagination.bx--pagination .bx--pagination__items-count {\n    font-size: 16px; }\n  .pagination.bx--pagination select {\n    padding-right: 45px; }\n\n@media (max-width: 671px) {\n  .pagination.bx--pagination {\n    justify-content: end; }\n    .pagination.bx--pagination .bx--pagination__items-count {\n      font-size: 14px; } }\n";
  const fileName = "Pagination_Pagination";
  const element = document.querySelector("style[data-sass-component='Pagination_Pagination']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Pagination = props => {
  const labels = {
    perPage: props.translate('pagination.per-page'),
    of: props.translate('pagination.of'),
    results: props.translate('pagination.results'),
    page: props.translate('pagination.page'),
    pages: props.translate('pagination.pages')
  };
  const onChange = data => {
    if (!props.onChange) {
      return () => {};
    }
    const targetPage = data.page;
    const perPageLimit = data.pageSize;
    props.onChange(targetPage, perPageLimit);
  };
  return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Pagination, {
    className: 'pagination',
    itemsPerPageText: labels.perPage,
    itemRangeText: (min, max, total) => `${min} – ${max} ${labels.of} ${total} ${labels.results}`,
    pageRangeText: (current, total) => `${total} ${total === 1 ? labels.page : labels.pages}`,
    pageSizes: props.pageSizes || [10, 20, 30, 40, 50],
    totalItems: props.totalItems || props.items.length,
    page: props.page,
    pageSize: props.pageSize,
    onChange: onChange
  });
};
Pagination.propTypes = {
  items: _propTypes.default.array.isRequired,
  translate: _propTypes.default.func.isRequired,
  page: _propTypes.default.number,
  pageSize: _propTypes.default.number,
  onChange: _propTypes.default.func,
  totalItems: _propTypes.default.number,
  pageSizes: _propTypes.default.array
};
var _default = exports.default = Pagination;